import { Formik } from "formik";
import { Form } from "react-router-dom";
import * as Yup from "yup";
import InputFormik from "../../../../common/components/form/InputFormik";
import ButtonWithLoader from "../../../../common/components/ui/loading/ButtonLoading";
import { maskLicensePlate } from "../../../../common/helpers/mask.helpers";
import { isLicensePlate } from "../../../../common/helpers/is-license-plate";
import { IVehicle } from "../../../../types/vehicle.type";

const validationSchema = Yup.object().shape({
  licensePlate: Yup.string()
    .required('Placa é obrigatório')
    .test(
      'invalid-plate',
      'placa inválida',
      isLicensePlate
    ),
  waitingTicket: Yup.string()
    .required('Senha é obrigatório')
});
type FormPropsCreateMaintenance = {
  onSubmit: (values: { name: string }) => Promise<void>;
  vehicleAnotherCompany: boolean | undefined;
  vehicle?: IVehicle;
  city?: string;
  licensePlate?: string
  readonly?: boolean
};

export default function FormCreateMaintenance(props: FormPropsCreateMaintenance) {
  const initialValues = { licensePlate: props.licensePlate };

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);
    await props.onSubmit(values);
    setSubmitting(false);
  };

  const formHTML = (isSubmitting, handleSubmit) => {
    return !props.vehicleAnotherCompany ? <Form >
      <InputFormik
        label='Informe a placa do veículo:'
        name='licensePlate'
        className='w-full'
        required={true}
        readonly={props.readonly}
        mask={maskLicensePlate}
      />

      <InputFormik
        label='Informe a senha do veículo:'
        name='waitingTicket'
        className='w-full mt-4'
        required={true}
        type="number"
      />

      <div className="flex justify-end">
        <ButtonWithLoader isLoading={isSubmitting} onClick={handleSubmit}> Enviar </ButtonWithLoader>
      </div>
    </Form>
      : <Form>
        <h2><strong>Este veículo é da base ({props.city}).</strong><br></br> Deseja continuar a manutenção de {props.vehicle?.licensePlate}?</h2>
        <div className="flex justify-end">
          <ButtonWithLoader isLoading={isSubmitting} onClick={handleSubmit}> Criar </ButtonWithLoader>
        </div>
      </Form>
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, handleSubmit }) => {
        return (
          formHTML(isSubmitting, handleSubmit)
        )
      }}
    </Formik>
  );
}
